import * as yup from "yup";

export const PlantaTratamientoSchema = yup.object().shape({
  orden: yup.number().required("errors.plantaTratamiento.orden.reuired"),
  nombre: yup
    .string()
    .max(100, "errors.plantaTratamiento.nombre.max")
    .required("errors.plantaTratamiento.nombre.required")
    .default(""),
  conManualOperacion: yup.boolean().required().default(false),
  descripcion: yup
    .string()
    .max(1024, "errors.plantaTratamiento.descripcion.max")
    .nullable()
    .required()
    .default(null),
  conPlanMantenimiento: yup.boolean().required().default(false),
  tecnologias: yup
    .array()
    .of(yup.object())
    .min(1, "errors.plantaTratamiento.tecnologias.min")
    .required("errors.plantaTratamiento.tecnologias.required")
    .default([]),
});
